var $8189bed27add1ad3$exports = {};
$8189bed27add1ad3$exports = {
    "close": `Zamknij`,
    "notifications": `Powiadomienia`
};


export {$8189bed27add1ad3$exports as default};
//# sourceMappingURL=pl-PL.mjs.map
